/** common */
export const FETCH_AVAILABLE_INVOICE_REQUEST = 'FETCH_AVAILABLE_INVOICE_REQUEST'
export const FETCH_AVAILABLE_INVOICE_SUCCESS = 'FETCH_AVAILABLE_INVOICE_SUCCESS'
export const FETCH_AVAILABLE_INVOICE_FAILED = 'FETCH_AVAILABLE_INVOICE_FAILED'
export const DOWNLOAD_SIMPLE_EXCEL_REQUEST = 'DOWNLOAD_SIMPLE_EXCEL_REQUEST'
export const DOWNLOAD_SIMPLE_EXCEL_SUCCESS = 'DOWNLOAD_SIMPLE_EXCEL_SUCCESS'
export const DOWNLOAD_SIMPLE_EXCEL_FAILED = 'DOWNLOAD_SIMPLE_EXCEL_FAILED'
export const DOWNLOAD_DETAIL_CSV_REQUEST = 'DOWNLOAD_DETAIL_CSV_REQUEST'
export const DOWNLOAD_DETAIL_CSV_SUCCESS = 'DOWNLOAD_DETAIL_CSV_SUCCESS'
export const DOWNLOAD_DETAIL_CSV_FAILED = 'DOWNLOAD_DETAIL_CSV_FAILED'
export const DOWNLOAD_INVOICE_PDF_REQUEST = 'DOWNLOAD_INVOICE_PDF_REQUEST'
export const DOWNLOAD_INVOICE_PDF_SUCCESS = 'DOWNLOAD_INVOICE_PDF_SUCCESS'
export const DOWNLOAD_INVOICE_PDF_FAILED = 'DOWNLOAD_INVOICE_PDF_FAILED'

/** summary */
export const FETCH_INVOICE_MONTHS_REQUEST = 'FETCH_INVOICE_MONTHS_REQUEST'
export const FETCH_INVOICE_MONTHS_SUCCESS = 'FETCH_INVOICE_MONTHS_SUCCESS'
export const FETCH_INVOICE_MONTHS_FAILED = 'FETCH_INVOICE_MONTHS_FAILED'
export const FETCH_SUMMARY_STATISTICS_REQUEST = 'FETCH_SUMMARY_STATISTICS_REQUEST'
export const FETCH_SUMMARY_STATISTICS_SUCCESS = 'FETCH_SUMMARY_STATISTICS_SUCCESS'
export const FETCH_SUMMARY_STATISTICS_FAILED = 'FETCH_SUMMARY_STATISTICS_FAILED'
export const FETCH_SUMMARY_MONTHS_REQUEST = 'FETCH_SUMMARY_MONTHS_REQUEST'
export const FETCH_SUMMARY_MONTHS_SUCCESS = 'FETCH_SUMMARY_MONTHS_SUCCESS'
export const FETCH_SUMMARY_MONTHS_FAILED = 'FETCH_SUMMARY_MONTHS_FAILED'
export const FETCH_SUMMARY_REGIONS_REQUEST = 'FETCH_SUMMARY_REGIONS_REQUEST'
export const FETCH_SUMMARY_REGIONS_SUCCESS = 'FETCH_SUMMARY_REGIONS_SUCCESS'
export const FETCH_SUMMARY_REGIONS_FAILED = 'FETCH_SUMMARY_REGIONS_FAILED'
export const FETCH_SUMMARY_WEEKS_REQUEST = 'FETCH_SUMMARY_WEEKS_REQUEST'
export const FETCH_SUMMARY_WEEKS_SUCCESS = 'FETCH_SUMMARY_WEEKS_SUCCESS'
export const FETCH_SUMMARY_WEEKS_FAILED = 'FETCH_SUMMARY_WEEKS_FAILED'
export const FETCH_SUMMARY_DATES_REQUEST = 'FETCH_SUMMARY_DATES_REQUEST'
export const FETCH_SUMMARY_DATES_SUCCESS = 'FETCH_SUMMARY_DATES_SUCCESS'
export const FETCH_SUMMARY_DATES_FAILED = 'FETCH_SUMMARY_DATES_FAILED'
export const FETCH_SUMMARY_PRODUCTS_REQUEST = 'FETCH_SUMMARY_PRODUCTS_REQUEST'
export const FETCH_SUMMARY_PRODUCTS_SUCCESS = 'FETCH_SUMMARY_PRODUCTS_SUCCESS'
export const FETCH_SUMMARY_PRODUCTS_FAILED = 'FETCH_SUMMARY_PRODUCTS_FAILED'
export const FETCH_SUMMARY_COMPARE_ESTIMATED_REQUEST = 'FETCH_SUMMARY_COMPARE_ESTIMATED_REQUEST'
export const FETCH_SUMMARY_COMPARE_ESTIMATED_SUCCESS = 'FETCH_SUMMARY_COMPARE_ESTIMATED_SUCCESS'
export const FETCH_SUMMARY_COMPARE_ESTIMATED_FAILED = 'FETCH_SUMMARY_COMPARE_ESTIMATED_FAILED'
export const FETCH_SUMMARY_COMPARE_PREV_MONTH_REQUEST = 'FETCH_SUMMARY_COMPARE_PREV_MONTH_REQUEST'
export const FETCH_SUMMARY_COMPARE_PREV_MONTH_SUCCESS = 'FETCH_SUMMARY_COMPARE_PREV_MONTH_SUCCESS'
export const FETCH_SUMMARY_COMPARE_PREV_MONTH_FAILED = 'FETCH_SUMMARY_COMPARE_PREV_MONTH_FAILED'
export const FETCH_TOTAL_COST_REQUEST = 'FETCH_TOTAL_COST_REQUEST'
export const FETCH_TOTAL_COST_SUCCESS = 'FETCH_TOTAL_COST_SUCCESS'
export const FETCH_TOTAL_COST_FAILED = 'FETCH_TOTAL_COST_FAILED'
export const FETCH_SUMMARY_DETAIL_REQUEST = 'FETCH_SUMMARY_DETAIL_REQUEST'
export const FETCH_SUMMARY_DETAIL_SUCCESS = 'FETCH_SUMMARY_DETAIL_SUCCESS'
export const FETCH_SUMMARY_DETAIL_FAILED = 'FETCH_SUMMARY_DETAIL_FAILED'
export const FETCH_COST_BY_MONTH_REQUEST = 'FETCH_COST_BY_MONTH_REQUEST'
export const FETCH_COST_BY_MONTH_SUCCESS = 'FETCH_COST_BY_MONTH_SUCCESS'
export const FETCH_COST_BY_MONTH_FAILED = 'FETCH_COST_BY_MONTH_FAILED'
export const FETCH_MODEL_WIDGET = 'FETCH_MODEL_WIDGET'
export const FETCH_CUSTOM_DASHBOARD_REQUEST = 'FETCH_CUSTOM_DASHBOARD_REQUEST'
export const FETCH_CUSTOM_DASHBOARD_SUCCESS = 'FETCH_CUSTOM_DASHBOARD_SUCCESS'
export const FETCH_CUSTOM_DASHBOARD_FAILED = 'FETCH_CUSTOM_DASHBOARD_FAILED'
export const SAVE_CUSTOM_DASHBOARD_REQUEST = 'SAVE_CUSTOM_DASHBOARD_REQUEST'
export const SAVE_CUSTOM_DASHBOARD_SUCCESS = 'SAVE_CUSTOM_DASHBOARD_SUCCESS'
export const SAVE_CUSTOM_DASHBOARD_FAILED = 'SAVE_CUSTOM_DASHBOARD_FAILED'
export const RESET_CUSTOM_DASHBOARD_REQUEST = 'RESET_CUSTOM_DASHBOARD_REQUEST'
export const RESET_CUSTOM_DASHBOARD_SUCCESS = 'RESET_CUSTOM_DASHBOARD_SUCCESS'
export const RESET_CUSTOM_DASHBOARD_FAILED = 'RESET_CUSTOM_DASHBOARD_FAILED'
export const UPDATE_EDIT_DASHBOARD = 'UPDATE_EDIT_DASHBOARD'
export const FETCH_CURRENT_PARAMS = 'FETCH_CURRENT_PARAMS'
